<div>
  <ng-content select="[header]"> </ng-content>
</div>
<div class="one-column-and-steps">
  <div [className]="stepsClass">
    <ng-content select="[steps]"></ng-content>
  </div>
  <div class="one-column-body">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
